import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useAuth } from '../AuthContext';
import UserStatus from './UserStatus';
import '../dashboard.css';
import API from '../api';


function Contact_Us() {

const [message, setMessage] = useState('');
const { user } = useAuth();
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
 
  const [values, setValues] = useState({
    user_id: user?.id,
    name: '',
    email: '',
    phone: '',
    feedback: ''
  });

  useEffect(() => {
    document.title = "Contact Us | TradeBarta.com";
  }, []);  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/contact_us`, values); // adjust URL as needed
      setMessage(res.data.message || 'Feedback sent!');
      setValues({ user_id: '', name: '', email: '', phone: '', feedback: '' }); // Clear form
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || 'Feedback submission failed');
    }
  };

  return (
<div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>   
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>

        <ul>
          <li><a href="/dashboard">Dashboard</a></li>
          <li><a href="/payment_history">Billing and Payment History</a></li>
          <li><a href="/referral_dashboard">Refer & Win</a></li>
          <li><a href="/profile">My Profile</a></li>
          <li><a href="/contact_us">Support</a></li>
        </ul>
      </aside>
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>

 <main className="main-content">
            <section className="data-table">
     
            <h4>Contact Us</h4>
         
          <form onSubmit={handleSubmit}>
            <div>
              <input
                type='text'
                name='name'
                placeholder="Name"
                value={values.name}
                required
                onChange={(e) => setValues({ ...values, user_id: user?.id, name: e.target.value })}
                className='form-input'
              />
            </div>
            <div>
              <input
                type='email'
                name='email'
                placeholder="Email"
                value={values.email}
                required
                onChange={(e) => setValues({ ...values, email: e.target.value })}
                className='form-input'
              />
            </div>
            <div>
              <input
                type='text'
                name='phone'
                placeholder="Phone"
                value={values.phone}
                required
                onChange={(e) => setValues({ ...values, phone: e.target.value })}
                className='form-input'
              />
            </div>
            <div>
              <textarea
                name="feedback"
                rows="5"
                placeholder="Type your message here..."
                value={values.feedback}
                required
                onChange={(e) => setValues({ ...values, feedback: e.target.value })}
                className='form-textarea'
              />
            </div>
            <div>
              <button type="submit" className="response-button">Submit</button>
            </div>
          </form>
          {message && <p style={{ marginTop: '15px', color: 'green' }}>{message}</p>}
        </section>
      </main>
    </div>
      </div>
  );
}

const inputStyle = {
  width: '40%',
  padding: '10px',
  fontSize: '1rem',
  borderRadius: '5px',
  marginTop: '10px',
  border: '1px solid #ccc',
};

export default Contact_Us;